import client from "./client";

const getVehicle = (vehicleID) => client.get("/vehicles/getVehicle/" + vehicleID);
const validateVehicle = (registration) => client.post("/vehicles/validateVehicle/", { registration });
const getVehicles = () => client.get("/vehicles");
const deleteVehicle = (vehicleID) => client.post("/vehicles/deleteVehicle", { vehicleID });
const addVehicle = (registration) =>
    client.post("/vehicles", {
        registration,
    });

export default {
    getVehicle,
    getVehicles,
    getVehicles,
    addVehicle,
    validateVehicle,
    deleteVehicle,
};
